import Typography from '@mui/material/Typography';


export default function PharmaDrugsSubText() {
  
  return (
<>


<Typography variant="subtitle2"> 

<Typography component="span" fontWeight={600}> Explore how your genetics influence medication response. </Typography>
Use the search bar below to find drug-specific guidance based on your genetic profile. 
This guide covers 184 medications for which pharmacogenetic recommendations are available.
When you search for a medication, you'll see one or more entries from trusted clinical sources, including CPIC, DPWG, the FDA, and FDA-PGx.
Each entry reflects how your unique genetic makeup may impact the way your body processes that drug—and what that means for your treatment.
<br /><br />
Click on any result to view a detailed summary including:

<ul style={{ paddingLeft: '20px' }}>

<li>
The gene involved in metabolizing the drug
</li>

<li>
Your individual genotype and corresponding enzyme function (phenotype)
</li>

<li>
Clinical implications of your result
</li>

<li>
Recommended actions or dose adjustments
</li>

<li>
The strength of the recommendation
</li>

<li>
A direct link to the full guideline or annotation for healthcare professionals.
</li>
</ul>

Please note: The column labeled <Typography component="span" fontWeight={600}> "Population"</Typography> indicates whether a guideline applies to a specific group, 
such as children or patients with a particular condition. Be sure to check that the recommendation is relevant for your situation.

<br /><br />

If any section shows a dash (-), it simply means that no specific caution is known for your genetic profile and this medication, 
or that further research is still needed to offer reliable guidance.

 </Typography>



</>

   )
}